module.exports = __webpack_public_path__ + "img/0e887fe.png";